import '@fontsource/inter'

const styles = () => ({
  // Sidebar Styles
  root: {
    padding: '23px 16px !important',
    width: '100% !important',
    height: '100% !important',
  },
  sidebarLogo: {
    marginBottom: '24px !important',
  },
  foodButton: {
    marginBottom: '4px !important',
  },
  divider: {
    marginBottom: '24px !important',
  },
  cursor: {
    cursor: 'pointer !important',
  },
  nameTypography: {
    fontFamily: 'Inter !important',
    fontStyle: 'normal !important',
    fontWeight: '500 !important',
    fontSize: '14px !important',
    lineHeight: '20px !important',
    color: '#344054 !important',
  },
  emailTypography: {
    fontFamily: 'Inter !important',
    fontStyle: 'normal !important',
    fontWeight: '500 !important',
    fontSize: '14px !important',
    lineHeight: '20px !important',
    color: '#667085 !important',
  },

  // CustomButton Styles
  customButton: {
    width: '14vw !important',
    textTransform: 'none !important',
  },
  logoGrid: {
    marginRight: '15px !important',
  },
  typography: {
    fontFamily: 'Inter !important',
    fontStyle: 'normal !important',
    fontWeight: '500 !important',
    fontSize: '16px !important',
    lineHeight: '24px !important',
  },
})

export default styles
